import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { Grid, Modal } from "semantic-ui-react";

import ModalApp from "../../components/ModalApp";
import { IMenuContextState, MenuContext } from "../../components/Menu/MenuContext";
import { INotificacao } from "../../interfaces";
import NotificationRepository from "../../Repositories/NotificationRepository";
import errors from "../../Utils/ExtractErrors";

interface IProps {
    id: string;
    title: string;
    onSuccess: () => void;
}

interface IState extends Omit<INotificacao, "recebedores"> {
    loading: boolean;
}

const initialState: IState = {
    id: "",
    criadaEm: "",
    criadaPor: "",
    descricao: "",
    mensagem: "",
    pessoaPendente: "",
    loading: true
}

export default function UserVisualizarNotificacao(props: IProps) {
    const menuContext = useContext<IMenuContextState>(MenuContext);

    const [state, setState] = useState<IState>(initialState);

    async function handleOnOpen() {
        try {
            setState(state => ({ ...state, loading: true }));

            const [notification] = await Promise.all([
                NotificationRepository.GetById({
                    id: props.id,
                    includeRecebedores: false
                }),
                NotificationRepository.SetViewed(props.id)
            ]);

            setState({ ...notification, loading: false });

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
    }

    function handleOnClose() {
        menuContext.loadNotifications();
        props.onSuccess();
    }

    const content = (
        <Modal.Content>
            <Grid>
                <Grid.Row textAlign="justified">
                    <Grid.Column>
                        {state.mensagem}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Modal.Content>
    );

    return (
        <ModalApp
            title={props.title}
            content={content}
            loading={state.loading}
            trigger={{
                icon: "eye",
                color: "blue"
            }}
            handleOpen={handleOnOpen}
            handleClose={handleOnClose}
            cancelText="Fechar"
        />
    );
}
